import { put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import * as actions from "../actions";
import * as constants from "../constants";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

function* handleFetchAllCallHistories({ payload }) {
  try {
    const { search, ...rest } = payload;
    const params = { ...rest, ...(search || {}) };

    const response = yield axios.get(`${baseURL}/api/v2/admin/call-histories`, {
      params,
    });

    if (response?.data?.success) {
      yield put(
        actions.fetchAllCallHistoriesSuccess({
          allCallHistories: response.data.data.callHistories || [],
          totalRecords: response.data.data.totalRecords || 0,
        })
      );
    } else {
      yield put(
        actions.fetchAllCallHistoriesError("Failed to fetch call histories")
      );
    }
  } catch (error) {
    errorHandler(error);
    yield put(actions.fetchAllCallHistoriesError(error.message));
  }
}

export default function* watcherCallHistoriesSaga() {
  yield takeEvery(
    constants.FETCH_ALL_CALL_HISTORIES,
    handleFetchAllCallHistories
  );
}
